jQuery(function () {

	let lowest_price = 0;
	let nights = 1;
	if (jQuery("input[name=nightQuantity]").length > 0) {
		nights = jQuery("input[name=nightQuantity]").val();
	}

	jQuery(".avg_price").each(function (index, el) {
		let str = jQuery(this).text().trim().split(' ');
		if (lowest_price > parseFloat(str[1].replace(/,/g, ''), 10) || lowest_price == 0) {
			lowest_price = parseFloat(str[1].replace(/,/g, ''), 10);
		}
	});
	lowest_price = lowest_price * nights;

	jQuery('.countprice').html(parseFloat(lowest_price).toFixed(2));
	jQuery('.countresults').html(jQuery(".items .item").size());

	jQuery(".room-container").each(function (index, el) {
		jQuery(this).find(".item-info").each(function (index, el) {
			if (index == 0) {
				jQuery(this).find(".item-select").prop('checked', true).trigger("change");
			}
			if (index > 2) {
				jQuery(this).css('display', 'none');
				jQuery(this).parents(".room-container").find(".view_all").removeClass('d-none');
			}
		});

	});

	jQuery(".item").each(function (index, el) {
		jQuery(this).find(".persons").each(function (index, el) {
			if (index == 0) {
				jQuery(this).addClass('first');
			}
			return;
		});
	});

	window.ajaxInProcess = false;

	jQuery('#company_invoice_data_switch').on('change', function () {
		jQuery('.company_invoice_data_wrapper').slideToggle();
		const inputs = document.querySelectorAll('.company_invoice_data_wrapper input, .company_invoice_data_wrapper select');
		for (let i = 0; i < inputs.length; i++) {
			const element = inputs[i];
			if (element.hasAttribute('required')) {
				element.removeAttribute('required');
				element.value = '';
			} else {
				element.setAttribute('required', 'required');
			}
		}
	});

});

// change rate price after a radio button is selected and populate input fields
jQuery(".item-select").on('change', function (event) {
	selected_room = jQuery(this).parents(".room-container").data("room");
	selected_price = jQuery(this).parents('.item-info').find(".item-price").data('rate-price');
	boardbasis = jQuery(this).parents('.item-info').find(".item-price").data('board-basis');
	availability = jQuery(this).data("availability");
	if (availability <= 0) {
		jQuery(this).parents('form').find(".book-now a").attr("href", backend_data['contact_page']).removeClass('submit').text(tr_strings.request_now).trigger("change");
	} else {
		jQuery(this).parents('form').find(".book-now a").attr("href", "").addClass('submit').text(tr_strings.book_now).trigger("change");
	}
	jQuery(this).parents("form").find('input[name="totalPrice_' + selected_room + '"]').val(selected_price);
	jQuery(this).parents('form').find('input[name="BoardBasis_' + selected_room + '"]').val(boardbasis);
});

jQuery(".view_all").on('click', function (event) {
	event.preventDefault();
	jQuery(this).parents(".room-container").find('.item-info:hidden').slideDown('fast');
	jQuery(this).addClass('d-none');
});

jQuery('#paymentAccordion').on('hide.bs.collapse', function (e) {
	jQuery(e.target.previousElementSibling).find('i').removeClass('fa-chevron-down').addClass('fa-chevron-right');
});

jQuery('#paymentAccordion').on('show.bs.collapse', function (e) {
	jQuery(e.target.previousElementSibling).find('i').removeClass('fa-chevron-right').addClass('fa-chevron-down');
});

const phone_number_input = document.querySelector('input[name="phone_number_container"]');
if (phone_number_input) {
	const iti = window.intlTelInput(phone_number_input, {
		preferredCountries: ['gb', 'de', 'at', 'be', 'nl', 'fr', 'it', 'ch', 'cz', 'pl', 'gr'],
		separateDialCode: true,
		customContainer: 'w-100',
		geoIpLookup: function (success, failure) {
			jQuery.get(tr_strings.ajax_url + '?action=geoip_detect2_get_info_from_current_ip', function () { }, "json").always(function (resp) {
				var countryCode = (resp && resp?.country?.iso_code) ? resp.country.iso_code : "gb";
				success(countryCode);
			});
		},
		initialCountry: 'auto',
		utilsScript: '/wp-content/themes/kos4all-theme/javascript/utils.js',
		autoPlaceholder: 'off'
	});
	jQuery(phone_number_input).on('blur', function (e) {
		if (iti.isValidNumber()) {
			phone_number_input.classList.remove('is-invalid')
			phone_number_input.parentElement.classList.remove('is-invalid')
			jQuery('input[name="phone_number"]').val(iti.getNumber());
		} else {
			phone_number_input.classList.remove('is-valid');
			phone_number_input.classList.add('is-invalid');
			phone_number_input.parentElement.classList.add('is-invalid');
			jQuery('input[name="phone_number"]').val('');
		}
	})
}

const main_email = document.querySelector('input[name="main_email"]');
if (main_email) {
	jQuery(main_email).on('blur', function () {
		jQuery.ajax({
			type: 'POST',
			url: tr_strings.ajax_url,
			data: { "email": this.value, "action": "kos4all_action_verify_email_ajax" },
			beforeSend: function () {
				if (window.ajaxInProcess) {
					request.abort();
					return false;
				}
				window.ajaxInProcess = true;
			},
			success: function (data) {
				if (data.data.result) {
					const email_validity_feedback_wrapper = document.querySelector(".email-validity-feedback");
					email_validity_feedback_wrapper.classList.remove('valid', 'invalid', 'unknown');
					email_validity_feedback_wrapper.classList.add(data.data.result);
					email_validity_feedback_wrapper.style.display = 'none';
					if (data.data.result == 'invalid') {
						email_validity_feedback_wrapper.style.display = 'block';
						email_validity_feedback_wrapper.innerHTML = data.data.reason;
					}
				}
			},
			complete: function () {
				window.ajaxInProcess = false;
			}
		})
	})
}

const only_uppercase_elements = document.querySelectorAll('.only-uppercase');
for (let index = 0; index < only_uppercase_elements.length; index++) {
	const element = only_uppercase_elements[index];
	jQuery(element).on('blur', function (e) {
		this.value = this.value.toUpperCase();
	});
}

const fullname_input = document.querySelector('input[name="fullname"]');
if (fullname_input) {
	jQuery(fullname_input).on('blur', function (e) {
		if (!this.checkValidity()) {
			this.nextElementSibling.style.display = 'block';
		} else {
			this.nextElementSibling.style.display = 'none';
		}
	})
}

// define the payment gateway
jQuery('button.payment-submit').on('click', function (event) {
	if (jQuery(this).data('payment') !== undefined) {
		const payment = jQuery(this).data('payment');
		// every time a .payment-submit button is clicked, there has
		// to be a .payment-form form element present in the same page
		jQuery('.payment-form').attr('data-payment', payment);
	}
	if (jQuery(this).data('submit') !== undefined) {
		jQuery('.payment-form').trigger('submit');
	}
});

// form submit via anchor
jQuery("form a.submit").on('click', function (event) {
	event.preventDefault();
	let acceptance = true;
	if (event.target.classList.contains('luggage-warning')) {
		acceptance = confirm(backend_data.luggage_warning);
	}
	if (acceptance) {
		jQuery(this).parents('form').trigger('submit');	
	}
});

jQuery('.payment-form').on('submit', function (event) {
	event.preventDefault();
	const form = event.target;
	if (form.checkValidity() === false) {
		event.stopPropagation();
		form.classList.add('was-validated');
		var scrollDistance = form.querySelector(':invalid').getBoundingClientRect().top;
		if (scrollDistance) {
			window.scrollBy(0, scrollDistance - 100);
		}
		return;
	}
	const payment_gateway = jQuery(form).data('payment');
	checkoutTag(payment_gateway);
	jQuery.ajax({
		type: "POST",
		url: tr_strings.ajax_url,
		data: jQuery(form).serialize() + "&payment=" + payment_gateway,
		beforeSend: function (request) {
			if (window.ajaxInProcess) {
				request.abort();
				return false;
			}
			window.ajaxInProcess = true;
		},
		success: function (data) {
			switch (payment_gateway) {
				case 'stripe':
				case 'paypal':
				case 'cash':
				case 'manual':
				case 'payment-notification':
				case 'credit':
					if (data.status == 'success') {
						jQuery('.loading-wrapper').show();
						window.location.assign(data.url);
						break;
					}
					if (data.status == 'failure') {
						modalFeedback(data.message);
						break;
					}
					modalFeedback("The Transaction could not be completed!<br>Please try again later!");
					break;
				case 'request':
					if (data.status == 'success') {
						jQuery('.loading-wrapper').show();
						window.location.assign(tr_strings.payment_success_url + "?rid=" + data.reservation_reference + "&email=" + data.email);
					} else {
						modalFeedback(data.message);
					}
					break;
			}
		},
		error: function (request, status, error) {
			modalFeedback(error + "<br>The Transaction could not be completed!<br>Please try again later!");
		},
		complete: function () {
			window.ajaxInProcess = false;
		}
	});
});

function modalFeedback(message) {
	jQuery('#generic-modal .modal-body').empty();
	jQuery('#generic-modal .modal-body').append(message);
	jQuery('#generic-modal').modal('show');
	jQuery('#generic-modal').on('hidden.bs.modal', function (e) {
		location.reload();
	});
}